import { useRouter } from 'next/router';

import { Language } from '@zep/types/common';

const SUPPORTED_LOCALES: Language[] = ['ko', 'en', 'ja'];

export function useLocale(): Language {
  const { locale } = useRouter();
  return SUPPORTED_LOCALES.includes(locale as Language)
    ? (locale as Language)
    : 'ko';
}
